import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetHealthProviderPostalCodeItemsDocument,
  GetHealthProviderPostalCodeItemsQueryVariables,
} from '../../types/api/graphql';

export function useHealthProviderPostalCodeItems(
  variables: GetHealthProviderPostalCodeItemsQueryVariables & {
    search?: string | null | undefined;
  }
) {
  const {
    data: healthProviderPostalCodeItemsData,
    loading: healthProviderPostalCodeItemsLoading,
  } = useCacheQuery(GetHealthProviderPostalCodeItemsDocument, {
    variables: {
      healthProviderId: variables.healthProviderId ?? '',
    },
    skip: !variables.healthProviderId,
  });

  const data = useMemo(
    () =>
      (healthProviderPostalCodeItemsData?.practicePostalCode ?? [])
        .map(option => option as string)
        .filter(
          option => !variables.search || option.search(variables.search) !== -1
        ),
    [healthProviderPostalCodeItemsData?.practicePostalCode, variables.search]
  );

  return {
    data,
    loading: healthProviderPostalCodeItemsLoading,
  };
}
